import React from "react";
import { Param, ParamTable } from "../Paramtable";
import { EndpointHeader } from "../Endpointheader";
import { CodeBlock } from "../Codeblock";
import { MethodBadge } from "../Methodbadge";

// ─── Params ───────────────────────────────────────────────────────────────

const QUERY_PARAMS: Param[] = [
  { name: "page", type: "number", required: true, description: "Page index (starts from 0)." },
  { name: "size", type: "number", required: true, description: "Number of records per page." },
  { name: "userId", type: "number", required: true, description: "User ID to fetch chatbot rules." },
];

// ─── Code Blocks ──────────────────────────────────────────────────────────

const CURL = `curl 'https://apiwhat.empedance.com/api/chatbot/search?page=0&size=10&userId=1' \\
  -H 'Authorization: Bearer <your_token>' \\
  -H 'Content-Type: application/json'`;

const RESPONSE_200 = `{
  "status": 1,
  "data": {
    "results": [
      {
        "id": 1,
        "keyword": "Hi",
        "responseText": "Hello! Welcome to Empedance.",
        "responseType": "TEXT",
        "mediaId": null,
        "createdAt": 1773245899000
      }
    ],
    "page": {
      "index": 0,
      "size": 10,
      "total": 9,
      "count": 1
    }
  },
  "error": null
}`;

// ─── Component ────────────────────────────────────────────────────────────

export const GetTrainBotSection: React.FC = () => {
  return (
    <div>
      <div className="flex items-center gap-3 mb-2">
        <MethodBadge method="GET" />
        <h1 className="text-2xl font-bold">Get Train Bot Rules</h1>
      </div>

      <p className="text-sm text-gray-500">
        Fetch chatbot training rules (keywords & responses) with pagination.
      </p>

      <EndpointHeader
        method="GET"
        url="/api/chatbot/search?page=0&size=10&userId=1"
      />

      <ParamTable title="Query Parameters" params={QUERY_PARAMS} />

      <CodeBlock
        title="Request Example"
        variants={[{ label: "cURL", value: CURL }]}
      />

      <CodeBlock
        title="RESPONSE 200 · OK"
        variants={[{ label: "JSON", value: RESPONSE_200 }]}
      />

      {/* Notes */}
      <div className="mt-5 p-4 bg-gray-50 border rounded-xl text-sm text-gray-700">
        <p className="font-semibold mb-2">📌 Response Notes:</p>
        <ul className="list-disc pl-5 text-xs space-y-1">
          <li><b>keyword</b>: Trigger word user sends</li>
          <li><b>responseType</b>: TEXT, IMAGE, VIDEO, DOCUMENT</li>
          <li><b>mediaId</b>: Required for non-text responses</li>
          <li><b>createdAt</b>: Timestamp (ms)</li>
        </ul>
      </div>
    </div>
  );
};